import React from "react";
import styled from "@emotion/styled";
import { QuickstartStepDefinition, QuickstartStepState } from "@ui/pages/program-builder/quickstart/quickstart-types";
import CheckIcon from "@assets/icons/check.svg";
import { colors } from "@ui/style/colors";
import ChevronRightIcon from "@assets/icons/chevron-right.svg";

interface QuickstartStepProps {
  step: QuickstartStepDefinition;
  state: QuickstartStepState;
}

export const QuickstartStep: React.FC<QuickstartStepProps> = ({ step, state }) => {
  const clickable = state === "active" || state === "completed";
  return (
    <Row
      type="button"
      data-state={state}
      disabled={!clickable}
      onClick={clickable ? () => step.onClick?.() : undefined}
      data-testid={`quickstart-step-${step.id}`}
    >
      <Bullet aria-hidden="true">
        {state === "completed" || state === "completed-disabled" ? <CheckIcon /> : null}
      </Bullet>
      <Texts>
        <Title>{step.title}</Title>
      </Texts>
      <EndIcon aria-hidden="true">
        <ChevronRightIcon />
      </EndIcon>
    </Row>
  );
};

const Row = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 5px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
  opacity: 0.55;
  text-align: left;
  width: 100%;
  font: inherit;
  &[data-state="active"] { opacity: 1; }
  &[data-state="completed"] { opacity: 1; }
  &[data-state="completed-disabled"] { opacity: 0.75; }
  &:hover { background: rgba(0,0,0,0.05); }
  &:disabled { cursor: default; }
  &:disabled:hover { background: transparent; }
`;

const Bullet = styled.span`
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border-radius: 50%;
  border: 2px solid ${colors.grey50};
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  [data-state="completed"] & {
    background: #A055F0;
    border-radius: 50%;
  border: none;
    color: #ffffff; 
  }
  [data-state="completed-disabled"] & {
    background: #D5D5DB;
    border-radius: 50%;
    border: none;
    color: #ffffff;
  }
  svg { width: 16px; height: 16px; display: block; }
`;

const Texts = styled.div`
  flex: 1;
  min-width: 0;
`;

const Title = styled.div`
  font-size: 16px;
  line-height: 1.25;
  font-weight: 700;
  color: #14202c;
  [data-state="completed-disabled"] & {
    color: #74748B;
  }
`;

const EndIcon = styled.span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  color: ${colors.grey50};
  svg { width: 20px; height: 20px; display: block; }
`;